import EmbeddedDocService from "../../../services/v2/bytepro/embeddedDoc.service";

export const embeddedDocApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getEmbeddedDoc({ commit }, { fileDataId, embeddedDocId }) {
      return EmbeddedDocService.getEmbeddedDoc(fileDataId, embeddedDocId).then(
        (resp) => {
          commit("dummyConsole", "EmbeddedDocService.getEmbeddedDoc - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "EmbeddedDocService.getEmbeddedDoc - error");
          return Promise.reject(error);
        }
      );
    },
    getEmbeddedDocs({ commit }, fileDataId) {
      return EmbeddedDocService.getEmbeddedDocs(fileDataId).then(
        (resp) => {
          commit(
            "dummyConsole",
            "EmbeddedDocService.getEmbeddedDocs - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "EmbeddedDocService.getEmbeddedDocs - error");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
